<template>
  <div id="header">
    <div id="member_logo" @click="toTop">
      <img src="https://triple-crown.co.jp/wp-content/themes/triplecrown_v2/images/logo.png" width="200" alt="" />
    </div>
    <p class="form_category" v-if="isUseCancel">
      {{ isPayment }}
    </p>
    <el-button v-if="isLogin" class="logout_btn" type="primary" plain @click="logout">ログアウト</el-button>
    <el-button v-if="isUseCancel" class="cancel_btn" type="warning" @click="cancel">申込みのキャンセル</el-button>
    <p class="store_name" v-if="!isUseCancel">{{ storeName }}</p>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data() {
    return {
      cancelDialog: false
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters['auth/isLogin']
    },
    isUseCancel() {
      return this.hasCancel
    },
    isPayment() {
      if (this.hasPayment === 'credit') {
        return '【信販（クレジット）】'
      } else {
        return '【自社割賦（分割）】'
      }
    },
    storeName() {
      return this.isLogin ? this.$store.state.auth.user.name ?? '' : ''
    },
    ...mapGetters({
      hasCancel: 'status/getHasCancel',
      hasPayment: 'status/getHasPayment'
    })
  },
  methods: {
    toTop(e) {
      this.$store.state.customer.tel = null
      this.$store.state.customer.user_id = null
      if (!this.isUseCancel) {
        if (!this.$store.state.login_page) {
          this.transitionClearCache('/')
          //this.transitionSame('top');
        }
      }
      e.preventDefault()
    },
    logout() {
      this.$loading({
        lock: true,
        text: 'Logout',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$store.dispatch('auth/logout')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
#header {
  position: fixed;
  background-color: #212121;
  left: 0;
  right: 0;
  top: 0;
  z-index: 500;
  //box-shadow: 0px 0px 5px rgba(0,0,0,0.3);
}
#member_logo {
  cursor: pointer;
}
</style>
